"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
require("antd/dist/antd.css");
require("normalize.css/normalize.css");
var react_1 = require("react");
var client_1 = require("react-dom/client");
// import '../importData/importProducts'
// import '../importData/importWarehouseItems'
// import '../importData/markOldNotificationsAsRead'
// import '../importData/warhouseQuantitiesController/updateQuantitiesStock'
// import "../importData/warhouseQuantitiesController/stockexam";
// import '../importData/warhouseQuantitiesController/updateWarehouseItemsDetails'
var react_redux_1 = require("react-redux");
require("./antDesign.index.css");
var Root_1 = __importDefault(require("./containers/Root"));
require("./index.modules.css");
require("./pages/News/createUserToken");
var store_1 = require("src/store");
var reduxHooks_1 = require("./hooks/reduxHooks");
var authSlice_1 = require("src/features/auth/authSlice");
function App() {
    var dispatch = (0, reduxHooks_1.useAppDispatch)();
    var _a = (0, reduxHooks_1.useAppSelector)(function (state) { return state.auth; }), status = _a.status, user = _a.user, error = _a.error, currentUser = _a.currentUser, currentUserStatus = _a.currentUserStatus;
    console.log({ currentUser: currentUser, status: status, user: user, currentUserStatus: currentUserStatus });
    (0, react_1.useEffect)(function () {
        dispatch((0, authSlice_1.checkAuthChange)());
    }, [dispatch]);
    return (0, jsx_runtime_1.jsx)(Root_1.default, {});
}
var container = document.getElementById("app");
var root = (0, client_1.createRoot)(container);
root.render((0, jsx_runtime_1.jsx)(react_redux_1.Provider, __assign({ store: store_1.store }, { children: (0, jsx_runtime_1.jsx)(App, {}) })));
